import { FC } from 'react'
import { useNavigate } from 'react-router-dom'
import { Importacao } from '../../core/_models'
import { RowActions } from '../../../../../../components'
import { IconPaths } from '../../../../../../../_metronic/helpers'

type Props = {
  importacao: Importacao
}

const ImportacoesActionsCell: FC<Props> = ({ importacao }) => {
  const navigate = useNavigate()
  const temErros = (importacao.registrosErros ?? 0) > 0
  const nome = importacao.descricao || importacao.nomeArquivo || 'Importação'

  const openRegistros = () => navigate(`/apps/importacao/detalhes/${importacao.id}`)
  const openErros = () => navigate(`/apps/importacao/erros/${importacao.id}`)

  // Lupa de detalhes no lugar do lápis das outras listagens: leva aos erros quando houver — é o
  // que pede atenção —, senão aos registros importados. As duas telas ficam também no menu.
  return (
    <RowActions
      itemName={nome}
      primaryAction={{
        label: 'Ver detalhes',
        onClick: temErros ? openErros : openRegistros,
        icon: IconPaths.Search,
      }}
      items={[
        { label: 'Ver registros importados', onClick: openRegistros },
        { label: 'Ver erros', onClick: openErros, hidden: !temErros },
      ]}
    />
  )
}

export { ImportacoesActionsCell }
